module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-INGEV9HD.360110f5.png";